import config from '../../config';
import { TenantFeatureFlagUpdate } from '../../domain/TenantSlice/TenantFeatureFlagUpdate';
import { TenantGlobalTaxUpdate } from '../../domain/TenantSlice/TenantGlobalTaxUpdate';
import { TenantAppointmentConfigUpdate } from '../../domain/TenantSlice/TenantAppointmentConfigUpdate';
import { TenantSetting } from '../../domain/TenantSlice/TenantSetting';
import ApiWrapperAuthenticated from '../Common/ApiWrapperAuthenticated';

export class TenantSettingsRepository 
    extends ApiWrapperAuthenticated<TenantSetting> {
    constructor() {
        super('tenants/');
    }
    
    async fetchTenantSettings(): Promise<TenantSetting | null> {
        return await this.getOneCustom({ url: ``, params: { tenantKey: config.tenant } });
    }
    
    async updateFeatureFlag(featureFlag: TenantFeatureFlagUpdate): Promise<void> {
        await this.putAuthenticatedCustom({ url: "feature-flag", data: featureFlag });
    }

    async updateGlobalTax(dto: TenantGlobalTaxUpdate): Promise<void> {
        await this.putAuthenticatedCustom({ url: "global-tax", data: dto });
    }

    async updateAppointmentConfig(dto: TenantAppointmentConfigUpdate): Promise<void> {
        await this.putAuthenticatedCustom({ url: "appointment-config", data: dto });
    }
}
